require('./passwordResetController');
require('./passwordResetSent/passwordResetSentController');
require('./passwordResetSave/passwordResetSaveController');
require('../shared/password/passwordDirective');

"use strict";

angular.module('app.passwordReset', [
  'app.passwordReset.passwordResetController',
  'app.passwordReset.passwordResetSent.passwordResetSentController',
  'app.passwordReset.passwordResetSave.passwordResetSaveController',
  'app.shared.password.passwordDirective'
])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {

      let resetTemplate = 'components/passwordReset/passwordResetView.html';
      let sentTemplate = 'components/passwordReset/passwordResetSent/passwordResetSentView.html';
      let saveTemplate = 'components/passwordReset/passwordResetSave/passwordResetSaveView.html';

      if (product.Code != 'htv') {
        resetTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetView.html';
        sentTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetSent/passwordResetSentView.html';
        saveTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetSave/passwordResetSaveView.html';
      }

      $stateProvider
        .state('app.passwordReset', {
          url: '/password_reset',
          template: '<ui-view></ui-view>',
          controller: [
            '$state', '$stateParams',
            function ($state, $stateParams) {
              if ($state.is('app.passwordReset')) {
                $state.go('app.passwordReset.request', $stateParams);
              }
            }
          ]
        })
        .state('app.passwordReset.request', {
          url: '/request',
          templateUrl: resetTemplate,
          controller: 'app.passwordReset.passwordResetController',
          params: {
            message: null
          },
          title: 'Password Reset',
          noSidebar: true,
          noTitleBar: true
        })
        .state('app.passwordReset.sent', {
          url: '/sent',
          templateUrl: sentTemplate,
          controller: 'app.passwordReset.passwordResetSent.passwordResetSentController',
          params: {
            email: null
          },
          title: 'Password Reset Request Sent',
          noSidebar: true,
          noTitleBar: true
        })
        .state('app.passwordReset.save', {
          url: '/save/:token',
          templateUrl: saveTemplate,
          controller: 'app.passwordReset.passwordResetSave.passwordResetSaveController',
          title: 'Save New Password',
          noSidebar: true,
          noTitleBar: true
        });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/passwordReset/passwordReset.js